<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <div class="flex justify-center items-center mt-5 mb-10">
      <select
        v-model="selected"
        class="h-10 w-full sm:w-2/4 rounded-md shadow-small border border-pink"
      >
        <option disabled value="">Please select a chat</option>
        <option
          v-for="option in options"
          :value="option"
          :key="option._id"
          :class="{ 'bg-gray-200 font-bold': option.watchStatus === 'LIVE' }"
          class="h-10 p-5 m-5"
        >
          {{ option.title }}
        </option>
      </select>
    </div>

    <div  v-if="showChat" class="bg-white overflow-hidden shadow rounded-lg">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h3
          class="flex justify-center items-center text-2xl leading-8 font-open-sans  tracking-wide text-lightblue font-extrabold
      sm:text-3xl sm:leading-9 py-3"
        >
          {{ selected.title }} -
          <span class="relative inline-flex h-4 w-4 ml-2">
            <span
              class="relative inline-flex items-center rounded-full h-4 w-4"
              :class="{ 'bg-red': isLive, 'bg-mustard': !isLive }"
            >
            </span>
          </span>
          <span v-if="isLive" class="ml-2 text-red">Live</span>
          <span v-else class="ml-2 text-mustard">OFFLINE</span>
        </h3>
      </div>

      <div class="px-4 py-5 sm:p-6 flex justify-center">
        <div class="w-full md:w-2/4">
          <chat-box :session="selected" :admin-chat="true"></chat-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  window.location.href = "/";
  import { sanityClient } from "../utils/sanity";
  import ChatBox from "../components/ChatBox";

  export default {
  name: "AdminChat",
  components: {ChatBox},
  data() {
    return {
      selected: '',
      options: [],
      id: null
    };
  },
  created() {
    this.fetchSessions();
  },
    computed: {
    showChat() {
      return typeof this.selected === "object";
    },
      isLive() {
      return this.selected.watchStatus === 'LIVE'
      }
    },
  methods: {
    preselectOption() {
      if (this.$route.params.id !== 'undefined' && this.$route.params.id != null) {
        this.selected = this.options.filter(el => el._id === this.$route.params.id)[0]
      }
    },
      fetchSessions(){
        const queryString = `
    {
        "sessions" :  *[_type == 'session']{
         speakers[]->{...},
            productCompatibility[]->{...},
             ...
             },
    }
    `;

        sanityClient
        .fetch(queryString)
        .then(res => {
          console.log(res);
          console.log(res);
          this.options = res.sessions;
          this.preselectOption();
        })
        .catch(error => console.log(error))

      }
  }
};
</script>
<style></style>
